module.exports = "/assets/data/4524cf1cf266ab0604118af575b6c303-NR16.data.json";